function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        console.log('open true')
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    console.log('open menu true')
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    console.log('close menu')
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        
        // :: FLOW INTERNATIONAL CHECKOUT PRICE UPDATE :: //
        if (typeof flow_ic_enabled != "undefined") {
          Flow.init(); 
        }
        document.querySelectorAll('variant-radios input:checked').forEach((item)=>{ 
          document.querySelector('.quick-add-modal__content-info .carousel-thumb-container ul>li.product__media-item[data-color="'+item.value.toLowerCase()+'"]')?.click();
          item.closest('fieldset').querySelector('.selected-value').innerHTML = item.value;
          item.closest('fieldset').querySelector('.media-color-style').innerHTML = `.product__media-wrapper li.product__media-item[data-color="${item.value.toLowerCase()}"],.thumbnail-list li.thumbnail-list__item[data-color="${item.value.toLowerCase()}"]{display:block;}`;
        })  
        if(document.querySelector('fieldset[product-option="color"] input:checked') != null){
          var selected_color = document.querySelector('fieldset[product-option="color"] input:checked').value;
          this.getVariantData().forEach((v,i)=>{
            if(selected_color == v.option1){
              if(!v.available){
                $(`input[type="radio"][value='{v.option2}']`).removeClass('disabled');
                $(`input[type="radio"][value='{v.option1}']`).removeClass('disabled');
               }else{
                $(`input[type="radio"][value='{v.option2}']`).addClass('disabled');
                $(`input[type="radio"][value='{v.option1}']`).addClass('disabled');
              }
            }
          })
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    //return false;
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});
var ct = 0;
var pt = 0;

function quickView() {
  $(document).on('click','.quick-view',function () {
    document.dispatchEvent(new CustomEvent('ais_quickview:loaded', {
      detail: {
        productId: this.getAttribute('data-pd-id')
      }
    }));
    
    var product_handle = $(this).data('handle');
    if ($(this).closest('.ais-Hits-item').find('.ais-rating--hide').is(':empty')) {
      var average_score = 0;
    } else {
      var average_score = $(this).closest('.ais-Hits-item').find('.ais-rating--hide').text();
    }
    if ($(this).closest('.ais-Hits-item').find('.ais-rating--counter-hide').is(':empty')) {
      var total_review = 0;
    } else {
      var total_review = $(this).closest('.ais-Hits-item').find('.ais-rating--counter-hide').text();
    } 
    var price_discount = $(this).closest('.ais-Hits-item').find('.ais-hit--price-discount').text();
    if ($('#quick-view').length == 0) {
      $("body").append('<div id="quick-view"></div>');
    }
    $('#quick-view').addClass(product_handle);
    var target_product;
    var color_image_list_map = {};
    var selected_color;
    
    jQuery.getJSON(`/products/${product_handle}.js`, function (product) {
      target_product = product;
      console.log('Product: ' + product.id);
      var title = product.title;
      var vendor = product.vendor;
      var type = product.type;
      var price1 = product.price;
      var price = '';
      var original_price = '';
      var price_ratio = '';
      var discount_ratio = 1.0 - price_ratio;
      var desc = product.description;
      var images = product.images;
      var media = product.media;
      var variants = product.variants;
      var sku = variants[0].sku
      var sellable = (product.available == true) ? 'In Stock' : 'Out Of Stock';
      var options = product.options;
      var url = '/products/' + product_handle;
      var color_length = options[0].values.length;
      var id = product.id;      
      $('.qv-product-title').text(title);
      $('.qv-product-vendor').text(vendor);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.qv-product-sellable').text(sellable);
      $('.view-product, .Shipping_info .product_link').attr('href', url);      
      $('#swym-quick-view').attr('data-product-url', location.origin + url);
      $('.qv-product-save').text(price_discount);
      $('#swym-quick-view, .wishlist_button').attr('data-product-id', id);

      if(average_score !=0 ){
          $('.review_val').html(
             '<span class="sky_yotpo_review yotpo"><span class="yotpo-stars"><span class="sr-only">' + average_score + ' star rating</span></span><span class="yotpo-total_review"> (' + total_review + ')</span></span>'                                     
          );
      }
      if (average_score == 0){
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');
        }else if(average_score <= 0.5) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-half-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');            
        }else if (average_score <= 1 ) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');
        }else if (average_score <= 1.5) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-half-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');
        }else if (average_score <= 2) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');
        }else if (average_score <= 2.5) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-half-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');
        }else if (average_score <= 3) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');
        }else if (average_score <= 3.5) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-half-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');
        }else if (average_score <= 4) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>');
        }else if (average_score <= 4.5) {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-half-star rating-star pull-left"></span>');
        }else {
          $('.yotpo-stars').prepend('<span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span>');
        }
      
      var imageCount = $(images).length;
      sku = sku.split('-')[0];
      $('.qv-content .product-number .product-sku').html(sku)
     
       $(media).each(function(i, image) { 
         console.log('alt- '+ image.alt);
        if(image.alt && !image.alt.startsWith('#swatch')){
          if (color_image_list_map[image.alt.toLowerCase()]) {
              color_image_list_map[image.alt.toLowerCase()].push(image.src);	
          } else {
              color_image_list_map[image.alt.toLowerCase()] = [image.src];
          }				
        }else {
          if(image.alt && image.alt.startsWith('#swatch')){
            
          }else{
            if(color_image_list_map['all_img']){
              color_image_list_map['all_img'].push(image.src);
            }else{
              color_image_list_map['all_img'] = [image.src];
            }
          }
        }         
      });
      $(options).each(function (i,option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append(`
        <div class="option_comman option-selection-${opt.toLowerCase()}">
          <span class="option nn">${opt}:<span class="selected"></span></span>
          <select class="option-${i} option ${opt.toLowerCase()}"></select>
          <div class="option_in_radio option_${opt.toLowerCase()} ${opt.toLowerCase()}"></div>
        </div>
        `);
        $(option.values).each(function (i, value) {
          $(`.option.${opt.toLowerCase()}`).append(`<option value='${value}'>${value}</option>`);
        });
        console.log(opt.toLowerCase()+' option ');
        if(opt.toLowerCase() == 'color'){
          $(option.values).each(function (i,value) {
            var current = i;
            if(i==0){
              var color_added = true;
              $(media).each(function(i,image) {
                if(image.alt){
                   var alts = image.alt.toLowerCase();
                 }else{
                   var alts = '';
                 }
                if (value == '/') {
                   var val = value.replace('/','_');
                 }else{
                   var val = '';
                 }
                image = image.src;
                if(alts.indexOf('swatch') > -1){
                  if(alts.split('#swatch_')[1].toLowerCase() == value.toLowerCase().replace('/','_') ){
                    //console.log('iii: ' + i +'<br>alt: ' + alts.split('#swatch_')[1].toLowerCase() + 'value: ' + value.toLowerCase().replace('/','_'));
                    $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}' checked="true"><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label"><img src="${image}"></label>`);
                    color_added = false;
                    return false;
                  }
                } else {
                   //console.log('iii_color_option: ' + i +'<br>alt: ' + alts.toLowerCase() + '  value: ' + value.toLowerCase().replace('/','_'));
                }
              })
              if(color_added){
                color_image_list_map['#color_'+value.toLowerCase()]? $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}'><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label"><img src="${color_image_list_map['#color_'+value.toLowerCase()][0]}"></label>`)
                :$(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}'><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label"><img src="${color_image_list_map['all_img'][0]}"></label>`);
              }
            }else{
              var color_added = true;
              $(media).each(function(i,image) {
                
                if(image.alt){
                   var alts = image.alt.toLowerCase();
                 }else{
                   var alts = '';
                 }
                if (value == '/') {
                   var val = value.replace('/','_');
                 }else{
                   var val = '';
                 }
                image = image.src;
                if(alts.indexOf('swatch') > -1){
                  if(alts.split('#swatch_')[1].toLowerCase() == value.toLowerCase().replace('/','_') ){
                    //console.log('i: ' + i +'<br>alt: ' + alts.split('#swatch_')[1].toLowerCase() + 'value: ' + value.toLowerCase().replace('/','_'));
                    $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}'><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label"><img src="${image}"></label>`);
                    color_added = false;
                    return false;
                  }
                } else {
                   //console.log('i_color_option: ' + i +'<br>alt: ' + alts.toLowerCase() + '  value: ' + value.toLowerCase().replace('/','_'));
                }
              })
              if(color_added){ 
                color_image_list_map['#color_'+value.toLowerCase()]? $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}'><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label"><img src="${color_image_list_map['#color_'+value.toLowerCase()][0]}"></label>`)
                : $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}'><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label"><img src="${color_image_list_map['all_img'][0]}"></label>`);
              }
            }
          });
        }else if(opt.toLowerCase() == 'size'){
          $(option.values).each(function (i,value) {
            if(i==0){
              if(!isNaN(value)){
                $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}' checked><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label">${value}</label>`);
              }else{
                $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}' checked><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label no-number">${value}</label>`);
              }
            }else{
              if(!isNaN(value)){
                $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}'><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label">${value}</label>`);
              }else{
                $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}'><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label no-number">${value}</label>`);
              }
            }
          });
        }else{
          $(option.values).each(function (i,value) {
            if(i==0){
              $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}' checked><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label">${value}</label>`);
            }else{
              $(`.option_in_radio.option_${opt.toLowerCase()}`).append(`<input type="radio" id="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" value='${value}'><label for="option_${opt.toLowerCase()}_main_${i}" name="${opt.toLowerCase()}" class="short-label">${value}</label>`);
            }
          }); 
        }
        var selected_option = $('.option_comman.option-selection-'+opt.toLowerCase()).find('select.option').val();
        $('.option_comman.option-selection-'+opt.toLowerCase()).find('.option .selected').html(selected_option)
      });
      
      var select_variant = false;
      var product_av = false;
      var first_vari = true
      
      $(product.variants).each(function (i,v) {
        console.log('product_first:' + v.available);
        if (!v.available) {
          $(`input[type="radio"][value='${v.option2}']`).addClass('disabled');
          $(`input[type="radio"][value='${v.option1}']`).addClass('disabled');
          if(first_vari){
            price = parseInt(v.price / 100);
            original_price = parseInt(v.compare_at_price / 100);            
            $('.qv-product-price').text('$' + price);
            $('.qv-product-price,.qv-product-original-price').removeClass('flow-localized');
            $('.qv-product-price').attr('flow-variant',v.id);
            $('.qv-product-original-price').attr('flow-variant',v.id);
            if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price).show();
            } else {
              $('.qv-product-original-price').hide();
            }
            first_vari = false;
          }
        } else {
          price = parseInt(v.price / 100);
          original_price = parseInt(v.compare_at_price / 100);          
          $('.qv-product-price').text('$' + price);
          $('.qv-product-price,.qv-product-original-price').removeClass('flow-localized');
          $('.qv-product-price').attr('flow-variant',v.id);
          $('.qv-product-original-price').attr('flow-variant',v.id);
          if (original_price != price) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          
          $(`input[type="radio"][value='${v.option1}'] + label`).click();
          $(`input[type="radio"][value='${v.option2}'] + label`).click();
          $(`input[type="radio"][value='${v.option3}'] + label`).click();
          $('select.option-0').val(v.option1);
          $('select.option-0').change();
          $('select.option-1').val(v.option2);
          $('select.option-1').change();
          $('select.option-2').val(v.option3);
          $('select.option-2').change();
          product_av = true;
          $(`input[type="radio"][value='${v.option1}']`).addClass('enabled'); 
          $(`input[type="radio"][value='${v.option2}']`).addClass('enabled'); 
          $(`input[type="radio"][value='${v.option2}']`).removeClass('disabled');
          $(`input[type="radio"][value='${v.option1}']`).removeClass('disabled');
          $('#swym-quick-view, .qv-add-button').attr('data-variant-id', v.id);
          return false
        }
      });
      if(!product_av){
        $('#quick-view select').change();
      }
    });

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      var size_select = false;
      if( $(this).hasClass("color") || jQuery('#quick-view select').length == 1){
        size_select = true;
      }
      selected_color = $('#quick-view select.color').val().toLowerCase();      
      if (String(selected_color).indexOf('/') > -1) {
       selected_color = $('#quick-view select.color').val().replace('/','_').toLowerCase();
      }
      console.debug('qv:', selected_color);
      var images = color_image_list_map['#color_'+selected_color]?color_image_list_map['#color_'+selected_color]:color_image_list_map['all_img'];
      if(images && images.length>0 && size_select){ 
        
        if( $('.qv-product-images').hasClass('slick-slider') ){
          $('.qv-product-images').slick('unslick');
        }
        $('.qv-product-images').empty();
        
        $(images).each(function(i, image) {        
          var image_embed = '<div data-color="#color_'+ selected_color +'"><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_400x.jpg').replace('.png', '_400x.png');
          $('.qv-product-images').append(image_embed);
        });
        $('.qv-product-images').slick({
          dots: true,
          infinite: true,
          fade: true,
          cssEase: 'linear'
        }).css('opacity', '1');
        
        // if (i == imageCount - 1) {
        //   var image_embed = '<div data-color="'+ alts +'"><img src="' + image + '"></div>';
        //   image_embed = image_embed.replace('.jpg', '_400x.jpg').replace('.png', '_400x.png');
        //   if(String(alts).indexOf('swatch') > -1 || String(alts).indexOf('null') > -1 ){
        //   } else {
        //    $('.qv-product-images').append(image_embed);
        //   }
        //   $('.qv-product-images').slick({
        //     dots: true,
        //     infinite: true,
        //     fade: true,
        //     cssEase: 'linear'
        //   }).css('opacity', '1');

        // } else {
        //   image_embed = '<div data-color="'+ alts +'"><img src="' + image + '"></div>';
        //   image_embed = image_embed.replace('.jpg', '_400x.jpg').replace('.png', '_400x.png');
        //   if(String(alts).indexOf('swatch') > -1 || String(alts).indexOf('null') > -1){
        //   }else{
        //     $('.qv-product-images').append(image_embed);
        //   }
        // }
      }
      // var slide_index = jQuery('.qv-product-images div[data-color="#color_'+selected_color+'"]:not(.slick-cloned)').attr('data-slick-index')*1;
      //       // console.log('selected_color_selected:' + selected_color);
      //       // console.log('slide_index:' + slide_index);
      //       // jQuery('.qv-product-images').slick('slickGoTo', slide_index);
      // jQuery('.qv-product-images').slick('slickGoTo', slide_index);
      
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        }else{
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      jQuery.getJSON(`/products/${product_handle}.js`, function (product) {
        $(product.variants).each(function (i, v) {
          if(selectedOptions.indexOf(v.option1)>=0 && size_select){
            if(v.available){
                $(`input[type="radio"][value='${v.option2}']`).removeClass('disabled');
                $(`input[type="radio"][value='${v.option1}']`).removeClass('disabled');
             }else{
                $(`input[type="radio"][value='${v.option2}']`).addClass('disabled');
                $(`input[type="radio"][value='${v.option1}']`).addClass('disabled');
            }
          }
          
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            var v_ava = v.available;
            $('.qv-product-price').text('$' + price);
            $('.qv-product-original-price').text('$' + original_price);
            $('.qv-product-price,.qv-product-original-price').removeClass('flow-localized');
            $('.qv-product-price').attr('flow-variant',v.id);
            $('.qv-product-original-price').attr('flow-variant',v.id);
            
            if (v.available) {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              $('.qv-product-sellable').addClass('avail').removeClass('unavail').text('In Stock');
              $(`input[type="radio"][value='${v.option2}']`).removeClass('disabled');
              $(`input[type="radio"][value='${v.option1}']`).removeClass('disabled');
              //$(`input[type="radio"][value='${v.option2}']`).prop('checked',false);
            } else {
              $('.qv-add-button').prop('disabled', true).val('Sold Out');
              $('.qv-product-sellable').removeClass('avail').addClass('unavail').text('Out Of Stock');
              $(`input[type="radio"][value='${v.option2}']`).addClass('disabled');
              $(`input[type="radio"][value='${v.option1}']`).addClass('disabled');
            }
          }
        });
      });
    });

    $.fancybox({
      href: '#quick-view',
      maxWidth: 900,
      maxHeight: 600,
      fitToView: false,
      width: '90%',
      height: '87%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      helpers     : { 
        overlay : {closeClick: false}
      },
      'beforeLoad': function () {             
        // var product_handle = $('#quick-view').attr('class');
        // if(product_handle == undefined) {
        //   interval = setInterval(function() {
        //     if($('#quick-view .product_link').length && $('#quick-view .product_link').attr('href') !== '') {
        //       product_handle = $('#quick-view .product_link').attr('href').replace('/products/','');
        //       console.warn('sky:product_handle',product_handle);
        //       clearInterval(interval);
        //     }
        //   }, 500);          
        // }
        console.warn('sky:product_handle',product_handle);
        $(document).on("click", ".qv-add-button", function (e) {
          var qty1 = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          
          jQuery.getJSON(`/products/${product_handle}.js`, function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title === selectedOptions) {
                var_id = v.id;
                 pt = ct;
                 ct = e.timeStamp;
                if(pt === 0 || ct !== pt){
                  processCart();
                }                
              }
            });
          });
          
          function processCart() {
            var thisCart = document.querySelector('#cart-drawer');
            var newFormData = new FormData();
            newFormData.append('id',var_id);
            newFormData.append('quantity',qty1);
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = newFormData;
            fetch('/cart/add', config)
              .then((response) => response.json())
              .then((response) => {
                if(response.status){
                  $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + response.description);
                } else {
                  setTimeout(function(){
                    $('body').trigger('added.ajaxProduct');   
                    $('.fancybox-close').trigger('click');
                  },500);
                }
              })   
            }
          
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible') && $('.qv-product-images').children().length) {
    $('.qv-product-images').slick('setPosition');
  }
});

customElements.define('product-recommendations', ProductRecommendations);

$('.header .search-modal__content.search-modal__content-bottom .search-modal__close-button.modal__close-button').on('click',function(e){
  console.log('close');
  $('.algolia-autocomplete').hide()
});
$(document).on('click','.modal-overlay',function(e){
      $('.algolia-autocomplete').hide();
});

$(document).on('change','.option_in_radio input',function(e){
  var option_es = $(this).val();
  if($(this).parents('.option_in_radio').hasClass('color')){
    $(this).parents('.option_comman').find('select.color').val(option_es).change();
    var option_name = $(this).parents('.option_comman').find('select.option').val();
    console.log('select '+option_name)
    $(this).parents('.option_comman').find('.selected').html(option_name);
  }else{
    $(this).parents('.option_comman').find('select.size').val(option_es).change();
    var option_name = $(this).parents('.option_comman').find('select.option').val();
    console.log('select '+option_name)
    $(this).parents('.option_comman').find('.selected').html(option_name);
  }
});

$(document).on('click','.ais-facets.show_filter .close',function(e){
  $(this).parents('.ais-facets').removeClass('show_filter');
})
$(document).on('click','.ais-facets.show_filter .clear_filter',function(e){
  $('.ais-clear-refinements-container .ais-ClearRefinements .ais-ClearRefinements-button').click();
});
$(document).on('click','.ais-facet-dropdown-wrapper .ais-range-slider--header',function(e){
  if($(window).width() <= 520){
    if($(this).parents('.ais-facet-dropdown-wrapper').hasClass('filter_active')){
      //$(this).parents('.ais-facet-dropdown-wrapper').removeClass('filter_active');
    }else{
      $('.ais-page .ais-facets .ais-facet-dropdown-wrapper').removeClass('filter_active');
      //$(this).parents('.ais-facet-dropdown-wrapper').addClass('filter_active'); 
      // var text_filter = $(this).text();
      // $(this).hide();
      // $('.ais-facets .title_filter .title').text(text_filter)
    } 
  }
});
$(document).on('click','.collection #MainContent .ais-facets .title_filter .title',function(e){
  $(this).text('Refine By');
  // $('.ais-page .ais-facets .ais-facet-dropdown-wrapper').find('.ais-range-slider--header').show().click();
  // $('.ais-page .ais-facets .ais-facet-dropdown-wrapper').removeClass('filter_active');
})
$(document).on('click','.refine-by',function(e){
  console.log('clicked');
  $(this).parents('.ais-page').find('.ais-facets').toggleClass('show_filter');
})
